module.exports = __webpack_public_path__ + "static/media/ABNB_CompTable_IPOIntelligence_a_base_wide.f5d41609.png";